'use client';

import FaqComponent from '@framework/ui/Pages/Landing/Sections/Faq';
import { faqCollection } from './faqCollection';
import styles from './styles.module.scss';

const Faq = () => {
  const activePanel = typeof window !== 'undefined'
    ? window.location.hash.slice(1)
    : '';

  return (
    <FaqComponent
      activePanel={ activePanel }
      collection={ faqCollection }
      wrapperClassName={ styles.wrapper }
    />
  );
};

export default Faq;
